import React from 'react';
import { css } from '@emotion/core';
import { Desktop, Tablet } from '../../constants/responsive';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
const Option = ({ name = 'LongTerm' }) => {
  const data = useStaticQuery(graphql`
    query {
      LongTerm: file(
        relativePath: { eq: "homepage/home-invest/long-term.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      CashManagement: file(
        relativePath: { eq: "homepage/home-invest/cash-management.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      Thematic: file(
        relativePath: { eq: "homepage/home-invest/thematic.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  return (
    <div
      css={css`
        flex: 0 0 auto;
        width: 220px;
        height: 220px;
        padding: 20px 35px 0 12px;
        border-radius: 15px;
        box-shadow: 0 3px 10px 2px rgba(0, 0, 0, 0.1);
        margin-right: 35px;
        :last-child {
          margin-right: 0;
        }
        position: relative;
        background: ${`url(${data[name].childImageSharp.fluid.src})`}
          center/auto 100% no-repeat border-box border-box;
        ${Tablet} {
          width: 286px;
          height: 286px;
          padding: 40px 20px 0 20px;
          box-shadow: 0 3px 10px 2px rgba(0, 0, 0, 0.1);
          margin-right: 35px;
          :last-child {
            margin-right: 0;
          }
          position: relative;
          background: ${`url(${data[name].childImageSharp.fluid.src})`}
            center/auto 100% no-repeat border-box border-box;
        }
        ${Desktop} {
          width: 286px;
          height: 286px;
          padding: 40px 20px 0 20px;
          box-shadow: 0 3px 10px 2px rgba(0, 0, 0, 0.1);
          margin-right: 35px;
          :last-child {
            margin-right: 0;
          }
          position: relative;
          background: ${`url(${data[name].childImageSharp.fluid.src})`}
            center/auto 100% no-repeat border-box border-box;
        }
      `}
    >
      <div
        css={css`
          font-size: 14px;
          font-weight: 500;
          line-height: 1.29;
          ${Tablet} {
            font-size: 18px;
            font-weight: 500;
            line-height: 1.33;
          }
          ${Desktop} {
            font-size: 18px;
            font-weight: 500;
            line-height: 1.33;
          }
        `}
      >
        Long-Term Asset Allocation Portfolios
      </div>
    </div>
  );
};

export default Option;
